import { NavLink, Outlet, Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { LayoutDashboard, FolderKanban, FileText, Receipt, Clock, ListChecks, Inbox, Users, CalendarDays, Images, Mail, Share2, ShieldCheck, CalendarCheck, SplitSquareHorizontal, PhoneCall } from "lucide-react";
import { useMe } from "@/components/portal/MeContext";

const ITEMS = [
  { to: "/portal", label: "Dashboard", icon: LayoutDashboard, roles: ["admin", "employee", "customer"], end: true },
  { to: "/portal/projects", label: "Projects", icon: FolderKanban, roles: ["admin", "employee", "customer"] },
  { to: "/portal/estimates", label: "Estimates", icon: FileText, roles: ["admin", "customer"] },
  { to: "/portal/invoices", label: "Invoices", icon: Receipt, roles: ["admin", "customer"] },
  { to: "/portal/calendar", label: "Calendar", icon: CalendarDays, roles: ["admin", "employee", "customer"] },
  { to: "/portal/appointments", label: "Visits", icon: CalendarCheck, roles: ["admin"] },
  { to: "/portal/time", label: "Time Clock", icon: Clock, roles: ["admin", "employee"] },
  { to: "/portal/tasks", label: "Tasks", icon: ListChecks, roles: ["admin", "employee"] },
  { to: "/portal/leads", label: "Leads", icon: Inbox, roles: ["admin"] },
  { to: "/portal/contacts", label: "Contact Log", icon: PhoneCall, roles: ["admin"] },
  { to: "/portal/users", label: "People", icon: Users, roles: ["admin"] },
  { to: "/portal/gallery", label: "Gallery", icon: Images, roles: ["admin"] },
  { to: "/portal/before-after", label: "Before & After", icon: SplitSquareHorizontal, roles: ["admin"] },
  { to: "/portal/newsletter", label: "Newsletter", icon: Mail, roles: ["admin"] },
  { to: "/portal/social", label: "Social", icon: Share2, roles: ["admin"] },
  { to: "/portal/activity", label: "Activity", icon: ShieldCheck, roles: ["admin"] },
];

const NavItem = ({ item }) => (
  <NavLink
    to={item.to}
    end={item.end}
    data-testid={`sidebar-${item.label.toLowerCase().replace(" ", "-")}-link`}
    className={({ isActive }) =>
      `flex shrink-0 items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-[#F2B91C] text-[#0E1F3F]" : "text-white/70 hover:bg-white/10 hover:text-white"}`
    }
  >
    <item.icon size={17} />{item.label}
  </NavLink>
);

export default function PortalLayout() {
  const me = useMe();
  const items = ITEMS.filter((i) => i.roles.includes(me.role));
  return (
    <div className="min-h-screen bg-[#FAF8F5] lg:flex">
      <aside className="no-print bg-[#0E1F3F] lg:sticky lg:top-0 lg:flex lg:h-screen lg:w-64 lg:shrink-0 lg:flex-col">
        <div className="flex items-center justify-between px-5 py-4 lg:py-6">
          <Link to="/" className="flex items-center gap-2 text-white" data-testid="portal-home-link">
            <img src="/brand/logo.png" alt="Firm Foundations" className="h-12 w-auto" />
          </Link>
          <div className="lg:hidden"><UserButton /></div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-1 lg:flex-col lg:overflow-y-auto">
          {items.map((i) => <NavItem key={i.to} item={i} />)}
        </nav>
        <div className="hidden items-center gap-3 border-t border-white/10 p-4 lg:flex">
          <UserButton />
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-white" data-testid="portal-user-name">{me.name}</p>
            <p className="text-xs capitalize text-[#F2B91C]" data-testid="portal-user-role">{me.role}</p>
          </div>
        </div>
      </aside>
      <main className="min-w-0 flex-1 px-4 py-8 sm:px-8 lg:px-12 lg:py-10">
        <Outlet />
      </main>
    </div>
  );
}
